import { EMPTY_ERROR_MESSAGE } from '@superdispatch/forms';
import { passwordCheckTypes } from 'shared/utils/PasswordUtils';
import {
  yupArray,
  yupBoolean,
  yupDateString,
  yupEnum,
  yupObject,
  yupOmit,
  yupPhone,
  yupString,
} from 'shared/utils/YupUtils';
import { InferType } from 'yup';

export type DispatcherDTO = InferType<typeof dispatcherSchema>;
export const dispatcherSchema = yupObject({
  guid: yupString(),
  name: yupString().required().max(200),
  email: yupString().required().email().max(200),
  phone: yupPhone(),
  created_at: yupDateString('DateTimeISO'),
  driver: yupObject({
    name: yupString().required().max(200),
    email: yupString().required().email().max(200),
    phone: yupPhone(),
    guid: yupString(),
  })
    .nullable()
    .optional(),
  p_changed_at: yupDateString('DateTimeISO').nullable(),

  is_activated: yupBoolean(),
  connection_status: yupEnum(
    ['activated', 'pending', 'deactivated', 'declined'],
    'activated',
  ),
  connection_type: yupEnum(['invite', 'join_request']),
  user: yupObject({
    guid: yupString(),
    status: yupString(),
    roles: yupArray(yupString()).nullable(),
  }).optional(),
});

export type DispatcherEditDTO = InferType<typeof dispatcherEditSchema>;
export const dispatcherEditSchema = dispatcherSchema.shape({
  guid: yupOmit,
  created_at: yupOmit,
});

export type DispatcherProfilePasswordDTO = InferType<
  typeof dispatcherProfilePasswordSchema
>;
export const dispatcherProfilePasswordSchema = yupObject({
  current: yupString().required(),
  new: yupString()
    .required(EMPTY_ERROR_MESSAGE)
    .min(8, EMPTY_ERROR_MESSAGE)
    .matches(passwordCheckTypes.toLowerCaseAndUpperCase, EMPTY_ERROR_MESSAGE)
    .matches(passwordCheckTypes.toSpecialCharacter, EMPTY_ERROR_MESSAGE)
    .matches(passwordCheckTypes.toNumber, EMPTY_ERROR_MESSAGE),
});

const VERIFICATION_CODE_ERROR = 'Your code must be composed of 6 digits';

export type DispatcherVerificationCodeDTO = InferType<
  typeof dispatcherVerificationCodeSchema
>;
export const dispatcherVerificationCodeSchema = yupObject({
  verification_code: yupString()
    .required(VERIFICATION_CODE_ERROR)
    .length(6, VERIFICATION_CODE_ERROR),
});

export type DispatcherPasswordVerificationDTO = InferType<
  typeof dispatcherPasswordVerificationSchema
>;
export const dispatcherPasswordVerificationSchema =
  dispatcherProfilePasswordSchema
    .concat(dispatcherVerificationCodeSchema)
    .shape({ verification_method: yupEnum(['email', 'sms'], 'email') });
